(function () {
  'use strict';

  var config = window.SimPurePerformanceConfig || {};
  var loadedScripts = Object.create(null);
  var engagementStarted = false;

  function loadScript(src, options, callback) {
    options = options || {};

    if (loadedScripts[src] || (options.id && document.getElementById(options.id))) return;
    loadedScripts[src] = true;

    var script = document.createElement('script');
    script.src = src;
    script.async = options.async !== false;

    if (options.id) script.id = options.id;
    if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
    if (callback) script.addEventListener('load', callback, { once: true });

    document.head.appendChild(script);
  }

  function runWhenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout });
    } else {
      window.setTimeout(callback, Math.min(timeout, 3000));
    }
  }

  function onFirstIntent(callback) {
    var completed = false;
    var events = ['pointerdown', 'keydown', 'touchstart'];

    function handleIntent() {
      if (completed) return;
      completed = true;

      events.forEach(function (eventName) {
        window.removeEventListener(eventName, handleIntent, true);
      });

      callback();
    }

    events.forEach(function (eventName) {
      window.addEventListener(eventName, handleIntent, { capture: true, passive: true });
    });
  }

  function onDocumentReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function startEngagementTools() {
    if (engagementStarted || config.designMode) return;
    engagementStarted = true;

    loadScript(
      'https://chat.quickcep.com/initQuickChat.js?platform=shopify&accessId=f797b6f9-5179-4ff0-8384-cf19789012d6',
      { id: 'quickCepScript' }
    );

    runWhenIdle(function () {
      loadScript(
        'https://www.gstatic.com/shopping/merchant/merchantwidget.js',
        { id: 'merchantWidgetScript' },
        function () {
          if (window.merchantwidget) {
            window.merchantwidget.start({ position: 'LEFT_BOTTOM' });
          }
        }
      );
    }, 2500);

    if (config.enableContentsquare) {
      window.setTimeout(function () {
        runWhenIdle(function () {
          loadScript('https://t.contentsquare.net/uxa/2e811b632dd71.js', { id: 'contentsquareScript' });
        }, 3000);
      }, 5000);
    }

    if (config.enableReconnect) {
      runWhenIdle(function () {
        loadScript(
          'https://admin-oneapp.inguzmana.com/scripts/reconnect-theme.js?shop=simpurelife-ms.myshopify.com&key=igz_pk_c2a7fcce3eaf0ea01ff65d08414a0a3a',
          { id: 'oneAppReconnectScript' }
        );
      }, 1500);
    }
  }

  function hydrateLazyAppSection(section) {
    if (!section || section.dataset.simpureHydrated === 'true') return;

    var template = section.querySelector('template[data-simpure-lazy-app-template]');
    if (!template) return;

    section.dataset.simpureHydrated = 'true';

    var fragment = template.content.cloneNode(true);

    fragment.querySelectorAll('script').forEach(function (originalScript) {
      var executableScript = document.createElement('script');

      Array.prototype.forEach.call(originalScript.attributes, function (attribute) {
        executableScript.setAttribute(attribute.name, attribute.value);
      });

      executableScript.textContent = originalScript.textContent;
      originalScript.replaceWith(executableScript);
    });

    section.replaceChildren(fragment);
    section.classList.add('is-hydrated');
    section.setAttribute('aria-busy', 'false');
  }

  function initializeLazyAppSections() {
    var sections = document.querySelectorAll('[data-simpure-lazy-apps]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(hydrateLazyAppSection);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        hydrateLazyAppSection(entry.target);
      });
    }, { rootMargin: '900px 0px' });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function optimizeHomepageHotspot() {
    var sectionRoot = document.querySelector('.__pf_FjchhJ5M');
    if (!sectionRoot || sectionRoot.dataset.simpureOptimized === 'true') return;

    sectionRoot.dataset.simpureOptimized = 'true';

    var section = sectionRoot.querySelector('[data-section-id="pf-9e4c"]');
    if (!section) return;

    if (!config.designMode) {
      var row = section.querySelector('[data-pf-type="Row"]');
      var responsiveBranches = row
        ? Array.prototype.filter.call(row.children, function (child) {
            return child.classList.contains('pf-c');
          })
        : [];

      if (responsiveBranches.length > 1) {
        var desktop = window.matchMedia('(min-width: 1000px)').matches;
        var branchToKeep = desktop
          ? responsiveBranches.find(function (branch) {
              return branch.classList.contains('pf-hide');
            })
          : responsiveBranches.find(function (branch) {
              return branch.classList.contains('pf-lg-hide');
            });

        if (branchToKeep) {
          responsiveBranches.forEach(function (branch) {
            if (branch !== branchToKeep) branch.remove();
          });
        }
      }
    }

    section.querySelectorAll('.jerry-hotspot-list').forEach(function (hotspotList) {
      var containers = Array.prototype.filter.call(hotspotList.children, function (child) {
        return child.classList.contains('hotspot-container');
      });

      containers.forEach(function (container) {
        container.querySelectorAll('img.pro-img').forEach(function (image) {
          var originalSrc = image.getAttribute('src') || '';
          var smallSrc = originalSrc.replace(/([?&])width=480(?=(&|$))/, '$1width=240');
          var optimizedSrc = originalSrc.replace(/([?&])width=480(?=(&|$))/, '$1width=400');

          image.loading = 'lazy';
          image.decoding = 'async';

          if (optimizedSrc !== originalSrc) {
            image.src = optimizedSrc;
            image.srcset = smallSrc + ' 240w, ' + optimizedSrc + ' 400w';
            image.sizes = '200px';
          }
        });
      });

      hotspotList._simpureHotspotContainers = containers;

      if (!config.designMode && containers.length > 1) {
        containers.forEach(function (container) {
          container.style.display = '';
        });
        hotspotList.replaceChildren(containers[0]);
      }
    });

    sectionRoot.addEventListener('click', function (event) {
      var closeButton = event.target.closest('.hotspot-item-close');
      if (closeButton) {
        sectionRoot.querySelectorAll('.hotspot-item.hover').forEach(function (item) {
          item.classList.remove('hover');
        });
        sectionRoot.querySelectorAll('.tooltip.show').forEach(function (tooltip) {
          tooltip.classList.remove('show');
        });
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var hotspot = event.target.closest('.hotspot-item');
      if (hotspot && sectionRoot.contains(hotspot)) {
        sectionRoot.querySelectorAll('.hotspot-item.hover').forEach(function (item) {
          item.classList.remove('hover');
        });
        sectionRoot.querySelectorAll('.tooltip.show').forEach(function (tooltip) {
          tooltip.classList.remove('show');
        });

        hotspot.classList.add('hover');
        var tooltip = hotspot.querySelector('.tooltip') || hotspot.nextElementSibling;
        if (tooltip && tooltip.classList.contains('tooltip')) tooltip.classList.add('show');
        return;
      }

      var tab = event.target.closest('.jerry-hotspot-tab > div');
      if (!tab || !sectionRoot.contains(tab)) return;

      var tabList = tab.parentElement;
      var index = Array.prototype.indexOf.call(tabList.children, tab);
      var hotspotList = tabList.nextElementSibling;

      Array.prototype.forEach.call(tabList.children, function (item) {
        item.classList.remove('active');
      });
      tab.classList.add('active');

      if (!hotspotList) return;

      var containers = hotspotList._simpureHotspotContainers || [];

      if (!config.designMode && containers[index]) {
        containers[index].style.display = '';
        hotspotList.replaceChildren(containers[index]);
      } else {
        containers.forEach(function (container, containerIndex) {
          container.style.display = containerIndex === index ? '' : 'none';
        });
      }
    });
  }

  onDocumentReady(initializeLazyAppSections);
  onDocumentReady(optimizeHomepageHotspot);
  onFirstIntent(startEngagementTools);
})();
